import type { BackendNotification, HttpPort, INotificationService } from "../contracts";

// NotificationService — wraps /api/notifications/*. Mirrors the original frontend's
// inline httpClient.get/post/delete pattern in UserNotification.tsx.
export class NotificationService implements INotificationService {
    constructor(private readonly http: HttpPort) {}

    async list(opts: { limit?: number; unreadOnly?: boolean; includeDismissed?: boolean } = {}): Promise<BackendNotification[]> {
        const qs = new URLSearchParams();
        qs.set("limit", String(opts.limit ?? 50));
        if (opts.unreadOnly) qs.set("unread_only", "true");
        qs.set("include_dismissed", opts.includeDismissed ? "true" : "false");
        const res = await this.http.get<{ records?: BackendNotification[] }>(`/api/notifications?${qs.toString()}`);
        return res.records ?? [];
    }

    async unreadCount(): Promise<number> {
        const res = await this.http.get<{ count?: number }>("/api/notifications/unread-count");
        return res.count ?? 0;
    }

    async markRead(notificationId: string): Promise<void> {
        await this.http.post(`/api/notifications/${encodeURIComponent(notificationId)}/mark-read`);
    }

    async markAllRead(): Promise<void> {
        await this.http.post("/api/notifications/mark-all-read");
    }

    async dismiss(notificationId: string): Promise<void> {
        await this.http.delete(`/api/notifications/${encodeURIComponent(notificationId)}`);
    }
}
